 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-printer</v-icon>
      <v-toolbar-title>Printer</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-flex>
        <v-autocomplete
          :items="printer"
          v-model="form.printId"
          :label="label.printId"
          item-text="label"
          item-value="value"
          data-vv-name="printId"
          :data-vv-as="label.printId"
          :error-messages="errors.collect('printId')"
          v-validate="'required'"
        ></v-autocomplete>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="closeDialog()">Cancel</v-btn>
      <v-btn color="primary" @click="assignData('schedule')">Print</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      form: {
        printId: null
      },
      label: {
        printId: 'Printer Name'
      },
      printer: []
    }
  },
  mounted() {
    this.getCommonDataList('printer')
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    assignData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('doAssign', this.form)
          this.$emit('close')
        }
      })
    }
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function (value) {
      this.getCommonDataList('printer')
    }
  },
  mixins: [commonAjaxMixin]
}
</script>
